import React from "react";
import { FileBrowseComposite } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/FileBrowseComposite";
import { DATA_SOURCES_TEST_PREFIX } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";
import { Divider, Flex, Select } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

export const SAPXMLSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  let file = config["datafile"];
  let directory = config["datadir"];

  const kSAPOptions = [
    { value: 0, label: appstr("sapoption1") },
    { value: 1, label: appstr("sapoption2") },
    { value: 2, label: appstr("sapoption3") }
  ];
  const BuildSAPOptions = () => {
    let options = [];
    let headers = kSAPOptions;

    for (let header of headers) {
      let option = {
        value: header.value,
        label: header.label,
        clickHandler: e => HandleFieldSelect(e)
      };
      options.push(option);
    }
    return options;
  };
  const HandleFieldSelect = option => {
    onChange({ ...config, SAPOption: option.value });
  };
  return (
    <Flex direction={"column"} gap={"12px"} width={"100%"}>
      <Flex direction={"column"}>
        <FileBrowseComposite
          file={file}
          directory={directory}
          includeBrowse
          onChange={onChange}
          config={config}
          importType={importType}
          chartConfig={chartConfig}
          index={index}
        />
      </Flex>
      <Divider />
      <Flex justifyContent={"space-between"} gap={"8px"}>
        <Select
          dataTestId={`${DATA_SOURCES_TEST_PREFIX}-sap-xml-orgunit-select`}
          listWidth={"large"}
          placeholder={"Select option..."}
          selectSize={"medium"}
          inputOnly={false}
          label={appstr("SAP OrgUnit Chart Options")}
          options={BuildSAPOptions()}
          value={config["SAPOption"]}
        />
      </Flex>
    </Flex>
  );
};
